import { h } from 'vue';
import { formatToDate, isArray, isFunction, isMap, isNil, replaceUrl } from '@mts-fe/utils';
import { CellFormat } from '../../types/table';

/** 格式化单元格内容 */
export default function (
  text: string,
  format: CellFormat | undefined,
  record: Recordable,
  index: number,
) {
  if (!format || text === '' || isNil(text)) {
    return text;
  }

  // custom function
  if (isFunction(format)) {
    return format(text, record, index);
  }

  // Map
  if (isMap(format)) {
    return format.get(text);
  }

  try {
    // date type
    const DATE_FORMAT_PREFIX = 'date|';
    if (format.startsWith(DATE_FORMAT_PREFIX) && text) {
      const dateFormat = format.replace(DATE_FORMAT_PREFIX, '');

      if (!dateFormat) {
        return text;
      }
      return formatToDate(text, dateFormat as any);
    }

    // 数组转字符串
    if (format.startsWith('array|') && isArray(text)) {
      const separator = format.replace('array|', '') || '、';
      return text.join(separator);
    }
    // 数值格式化（小数位0-9、%）
    if (format.startsWith('number|') && !isNil(text)) {
      console.error('此功能已废弃，请改为组件形式！');
      const _format = replaceUrl(format.replace('number|', ''), record);
      const fractionDigits = Number(_format.slice(0, 1));
      if (Number.isNaN(Number(text)) || Number.isNaN(fractionDigits)) {
        return text;
      }
      const num = _format.slice(1) === '%' ? Number(text) * 100 : Number(text);
      return num.toFixed(fractionDigits) + _format.slice(1);
    }
    // 文本后缀
    if (format.startsWith('suffix|') && !isNil(text)) {
      const suffixText = replaceUrl(format.replace('suffix|', ''), record);
      if (suffixText === '｜') return text;
      return text + suffixText;
    }
    // 自定义拼接
    if (format.startsWith('custom|') && !isNil(text)) {
      return replaceUrl(format.replace('custom|', ''), record);
    }
    // 文本换行替换
    if (format.startsWith('split|') && !isNil(text)) {
      const textArray = text.split(format.replace('split|', ''));
      return textArray.length > 1
        ? h(
            'div',
            textArray.map((i) => h('div', i)),
          )
        : text;
    }
  } catch (error) {
    return text;
  }
}
